<template>
<div ui-view="" class="app-body" id="view">
  <component v-bind:is="component"></component>
</div>
</template>

<script>
//import UserDetail from './UserDetail.vue'
import Manager from '@/views/app/inOut/Manager.vue'
import BookList from '@/views/app/inOut/BookList.vue'

export default {
  components: { Manager},
  data() {
    return {
      component: null
    }
  },
  mounted(){
    this.init();
  },
  watch:{
    $route(to) {
      this.init();
    }
  },
  methods: {
    init(){


      /*
      if(this.$route.query.mode== 'view'){
        this.component = UserDetail
        return;
      }
      */
      if(this.$route.query.mode== 'new'){
        //this.component = UserEdit
        return;
      }

      if(typeof this.$route.query.mode == "undefined" || this.$route.query.mode == 'list' || this.$route.query.mode == ''){

        if(this.$route.name  == 'inOut.bookList'){
          this.component = BookList
        } else{
          this.component = Manager
        }
        return;
      }
    }
  },
}
</script>

<style>

</style>
